export default __webpack_public_path__ + "bank-logo.png";